import React from 'react'
import { connect } from 'react-redux'
import { AppsList } from 'components/Layout'
import { appListRequest, installedAppListRequest } from '../../actions'

import { CreateNewAppButton } from './../Buttons'

class AppsListContainer extends React.Component {
	componentWillMount() {
		this.props.appListRequest()
		this.props.installedAppListRequest()
	}
	render() {
		return (
			<AppsList
				header={'All your apps'}
				info={<CreateNewAppButton label="New" />}
				apps={this.props.apps}
			/>
		)
	}
}

const SuggestedButton = () => (
	<CreateNewAppButton label={'Create'} type={'ghost'} />
)

const appsSuggestions = {
	'first-app': {
		category: 'Productivity',
		name: 'Your first app',
		shortDescription: 'Lift off with your next app.',
		status: 'suggestion',
		button: <SuggestedButton />
	},
	'weekend-hack': {
		category: 'Experiments',
		name: 'Your next weekend hack',
		shortDescription: 'Find out what you can do with the chat.io APIs.',
		status: 'suggestion',
		button: <SuggestedButton />
	},
	integration: {
		category: 'Desktop sharing',
		name: 'Your next integration',
		shortDescription:
			'Build an integration with a service you already use.',
		status: 'suggestion',
		button: <SuggestedButton />
	}
}

const mapStateToProps = (state, ownProps) => ({
	apps:
		Object.keys(state.apps.items).length > 0
			? state.apps.items
			: appsSuggestions
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	appListRequest: () => {
		dispatch(appListRequest())
	},
	installedAppListRequest: () => {
		dispatch(installedAppListRequest())
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(AppsListContainer)



// WEBPACK FOOTER //
// ./src/containers/AppList/AppList.js